// ========== frontend/src/LiveGeofenceDashboard.jsx ==========
import React, { useEffect, useState } from 'react';
import axios from 'axios';


// Componente Modal para comentarios
const CommentModal = ({ record, isOpen, onClose, user }) => {
    const [comments, setComments] = useState([]);
    const [newComment, setNewComment] = useState('');
    const [loading, setLoading] = useState(false);
    const [exceedanceId, setExceedanceId] = useState(null);
  
    useEffect(() => {
      if (isOpen && record) {
        fetchExceedanceId();
      }
    }, [isOpen, record]);
  
    const fetchExceedanceId = async () => {
      try {
        const res = await axios.get(
          `https://apitimeinzone.ebtapps.com/api/exceedance-id/${record.vehicle_name}/${record.geofence_name}`
        );
        setExceedanceId(res.data.exceedance_id);
        fetchComments(res.data.exceedance_id);
      } catch (err) {
        console.error('Error fetching exceedance ID:', err);
        setExceedanceId(null);
      }
    };
  
    const fetchComments = async (id) => {
      try {
        const res = await axios.get(`https://apitimeinzone.ebtapps.com/api/geofence-comments/${id}`);
        setComments(res.data);
      } catch (err) {
        console.error('Error fetching comments:', err);
      }
    };
  
    const handleAddComment = async () => {
      if (!newComment.trim() || !exceedanceId || !user) return;
  
      setLoading(true);
      try {
        await axios.post('https://apitimeinzone.ebtapps.com/api/geofence-comments', {
          exceedance_id: exceedanceId,
          user_id: user.id,
          username: user.name,
          comment: newComment
        });
  
        setNewComment('');
        fetchComments(exceedanceId);
      } catch (err) {
        console.error('Error adding comment:', err);
        alert('Error al agregar comentario');
      } finally {
        setLoading(false);
      }
    };
  
    if (!isOpen) return null;
  
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px' }}>
          <div className="modal-header">
            <h3>Comentarios - {record.vehicle_name} en {record.geofence_name}</h3>
            <button className="modal-close" onClick={onClose}>×</button>
          </div>
          
          <div className="modal-body">
            {/* Lista de comentarios existentes */}
            <div className="comments-section">
              <h4>Comentarios existentes:</h4>
              {comments.length === 0 ? (
                <p className="no-comments">No hay comentarios aún</p>
              ) : (
                <div className="comments-list">
                  {comments.map(comment => (
                    <div key={comment.id} className="comment-item">
                      <div className="comment-header">
                        <strong>{comment.username}</strong>
                        <span className="comment-date">
                          {new Date(comment.created_at).toLocaleString()}
                        </span>
                      </div>
                      <p className="comment-text">{comment.comment}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
  
            {/* Formulario para nuevo comentario */}
            <div className="add-comment-section">
              <h4>Agregar comentario:</h4>
              <textarea
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                placeholder="Escribe tu comentario aquí..."
                rows="4"
                className="comment-textarea"
                disabled={!exceedanceId || loading}
              />
              <div className="comment-actions">
                <button 
                  onClick={handleAddComment}
                  disabled={!newComment.trim() || !exceedanceId || loading}
                  className="btn-primary"
                >
                  {loading ? 'Agregando...' : 'Agregar Comentario'}
                </button>
              </div>
            </div>
          </div>
          
          <div className="modal-footer">
            <button className="btn-secondary" onClick={onClose}>Cerrar</button>
          </div>
        </div>
      </div>
    );
  };
  

// Componente Modal para mostrar el resumen del registro
const RecordModal = ({ record, isOpen, onClose }) => {
  if (!isOpen) return null;

  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${h}h ${m}m ${s}s`;
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Resumen del Registro</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div className="summary-grid">
            {record.order_id && (
            <div className="summary-item">
                <label>Número de orden:</label>
                <span>{record.order_id}</span>
            </div>
            )}
            {record.trailer_id && (
            <div className="summary-item">
                <label>Trailer:</label>
                <span>{record.trailer_id}</span>
            </div>
            )}
            <div className="summary-item">
              <label>Vehículo:</label>
              <span>{record.vehicle_name}</span>
            </div>
            <div className="summary-item">
              <label>Geocerca:</label>
              <span>{record.geofence_name}</span>
            </div>
            <div className="summary-item">
              <label>Tiempo dentro:</label>
              <span>{formatTime(record.seconds_inside)}</span>
            </div>
            <div className="summary-item">
              <label>Hora de entrada:</label>
              <span>{new Date(record.entered_at).toLocaleString()}</span>
            </div>
            {/*<div className="summary-item full-width">
              <label>ID del registro:</label>
              <span className="record-id">{record.id || 'N/A'}</span>
            </div> */}
          </div>
          
        </div>
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
};

export default function LiveGeofenceDashboard({ user }) {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filters, setFilters] = useState({ vehicle_name: '', geofence_name: '', seconds_inside: '', entered_at: '' });
  const [sortBy, setSortBy] = useState('seconds_inside');
  const [sortOrder, setSortOrder] = useState('desc');
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [alertThreshold, setAlertThreshold] = useState(7200); // 2 horas en segundos
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);


  const fetchData = async () => {
    console.log("fetchData");
    try {
      const token = sessionStorage.getItem('ebt_token_time_in_zone');
      const res = await axios.get('https://apitimeinzone.ebtapps.com/api/live-geofence-times', {
        headers: {
          'access-token': token
        }
      });
      setData(res.data);
    } catch (err) {
      console.error("Error fetching data", err);
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 15000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    let temp = [...data];

    // Filtros
    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        temp = temp.filter(item => item[key].toString().toLowerCase().includes(value.toLowerCase()));
      }
    });

    // Sort
    temp.sort((a, b) => {
      const direction = sortOrder === 'asc' ? 1 : -1;
      if (sortBy === 'entered_at') {
        return direction * (new Date(a.entered_at) - new Date(b.entered_at));
      }
      return direction * (a[sortBy] > b[sortBy] ? 1 : a[sortBy] < b[sortBy] ? -1 : 0);
    });

    setFilteredData(temp);
    setCurrentPage(1);
  }, [data, filters, sortBy, sortOrder]);

  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${h}h ${m}m ${s}s`;
  };

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(column);
      setSortOrder('asc');
    }
  };

  const renderSortArrow = (column) => {
    if (sortBy !== column) return null;
    return sortOrder === 'asc' ? (
      <span className="sort-arrow">▲</span>
    ) : (
      <span className="sort-arrow">▼</span>
    );
  };

  // Función para determinar si una fila debe resaltarse
  const shouldHighlightRow = (secondsInside) => {
    return secondsInside >= alertThreshold;
  };

  // Función para abrir el modal con el registro seleccionado
  const openModal = async (record) => {
    try {
      const res = await axios.get(`https://apitimeinzone.ebtapps.com/api/tractor-status/${record.vehicle_name}`);
      setSelectedRecord({ ...record, ...res.data });
    } catch (err) {
      console.warn('No se encontró movimiento activo:', err);
      setSelectedRecord(record); // Muestra solo info de geocerca
    }
    setIsModalOpen(true);
  };

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const displayedData = filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const columnLabels = {
    vehicle_name: 'Vehículo',
    geofence_name: 'Geocerca',
    seconds_inside: 'Tiempo Dentro',
    entered_at: 'Hora de Entrada',
    actions: 'Acciones'
  };

  // Función para abrir el modal de comentarios
  const openCommentModal = (record) => {
    setSelectedRecord(record);
    setIsCommentModalOpen(true);
  };

  return (
    <div className="dashboard-minimal">
      <div className="dashboard-header">
        <h2 className="dashboard-title">Tiempo en Geocercas</h2>
        
        <div className="alert-config">
          <label htmlFor="alertThreshold">Umbral de alerta (horas): </label>
          <input
            id="alertThreshold"
            type="number"
            min="0"
            step="0.5"
            value={alertThreshold / 3600}
            onChange={(e) => setAlertThreshold(Number(e.target.value) * 3600)}
            className="threshold-input"
          />
          <span className="config-help">* Filas con más tiempo se marcarán en rojo</span>
        </div>
      </div>

      <div className="table-container">
        <table className="minimal-table">
          <thead>
            <tr>
              {['vehicle_name', 'geofence_name', 'seconds_inside', 'entered_at', 'actions'].map(col => (
                <th key={col} onClick={() => col !== 'actions' && handleSort(col)}>
                  <div className="column-header">
                    <span className="column-title">
                      {columnLabels[col]}
                      {col !== 'actions' && renderSortArrow(col)}
                    </span>
                    {col !== 'actions' && (
                      <input
                        type="text"
                        value={filters[col] || ''}
                        onClick={e => e.stopPropagation()}
                        onChange={e => setFilters(prev => ({ ...prev, [col]: e.target.value }))}
                        className="filter-input"
                        placeholder={`Filtrar ${columnLabels[col]}`}
                      />
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {displayedData.length > 0 ? (
              displayedData.map((row, i) => (
                <tr 
                  key={i} 
                  className={shouldHighlightRow(row.seconds_inside) ? 'alert-row' : ''}
                >
                  <td>{row.vehicle_name}</td>
                  <td>{row.geofence_name}</td>
                  <td>
                    <span className={shouldHighlightRow(row.seconds_inside) ? 'highlighted-time' : ''}>
                      {formatTime(row.seconds_inside)}
                    </span>
                  </td>
                  <td>{new Date(row.entered_at).toLocaleString()}</td>
                  <td>
                    <div className="action-buttons">
                      <button 
                        className="btn-primary btn-sm"
                        onClick={() => openModal(row)}
                        title="Ver resumen"
                      >
                        👁️ Ver
                      </button>
                      <button 
                            className="btn-secondary btn-sm"
                            onClick={() => openCommentModal(row)}
                            title="Agregar comentario"
                            disabled={!user} // Deshabilitar si no hay usuario
                        >
                            💬 Comentar
                        </button>
                      {/* Espacio para futuros botones de acción */}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="no-data">No hay datos disponibles</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="pagination-container">
        <div className="pagination-info">
          Mostrando {displayedData.length} de {filteredData.length} registros
          {filteredData.filter(row => shouldHighlightRow(row.seconds_inside)).length > 0 && (
            <span className="alert-count">
              , <span className="alert-indicator">{filteredData.filter(row => shouldHighlightRow(row.seconds_inside)).length}</span> exceden el umbral
            </span>
          )}
        </div>
        
        <div className="pagination-controls">
          <div className="rows-per-page">
            <label>Filas por página:</label>
            <select
              value={rowsPerPage}
              onChange={(e) => setRowsPerPage(Number(e.target.value))}
            >
              {[10, 20, 50, 100].map(num => (
                <option key={num} value={num}>{num}</option>
              ))}
            </select>
          </div>
          
          <div className="page-navigation">
            <button 
              className="pagination-btn"
              disabled={currentPage === 1} 
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              ‹
            </button>
            
            <span className="page-info">
              Página {currentPage} de {totalPages || 1}
            </span>
            
            <button 
              className="pagination-btn"
              disabled={currentPage === totalPages || totalPages === 0} 
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              ›
            </button>
          </div>
        </div>
      </div>

      <RecordModal 
        record={selectedRecord} 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />

    <CommentModal 
        record={selectedRecord} 
        isOpen={isCommentModalOpen} 
        onClose={() => setIsCommentModalOpen(false)}
        user={user}
      />
    </div>
  );
}